import React, { Component } from 'react';
import ContactsTab from './ContactsTab';
// import ProfileTab from './ProfileTab';
import PassportTab from './PassportTab';
import AddressTab from './AddressTab';
import cx from 'classnames';
import {translate} from "react-i18next";

@translate(['modal'], {wait:true})
export default class ProfileSettings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentTab: 0,
    };
  }


  render() {
    const {t} = this.props;

    return (
      <div className="popup__content">
        <h2>{t('modal:personal__header')}</h2>
        <div className="popup__tab-set popup__tab-inline">
          <div className={cx('popup__tab-set__item', {active: this.state.currentTab === 0})}>
            <a onClick={(e) => {
              e.preventDefault();
              this.setState({
                currentTab: 0,
              });
            }}
            href="">{t('modal:personal__contacts')}</a>
          </div>
          {/* <div className={cx('popup__tab-set__item', {active: this.state.currentTab === 1})}>
            <a onClick={(e) => {
              e.preventDefault();
              this.setState({
                currentTab: 1,
              });
            }}
            href="">ФИО</a>
          </div> */}
          <div className={cx('popup__tab-set__item', {active: this.state.currentTab === 1})}>
            <a onClick={(e) => {
              e.preventDefault();
              this.setState({
                currentTab: 1,
              });
            }}
            href="">{t('modal:personal__passport')}</a>
          </div>
          <div className={cx('popup__tab-set__item', {active: this.state.currentTab === 2})}>
            <a onClick={(e) => {
              e.preventDefault();
              this.setState({
                currentTab: 2,
              });
            }}
            href="">{t('modal:personal__addresses')}</a>
          </div>
        </div>
        <div className="popup__tab__content">
          {
            this.state.currentTab === 0 &&
            <ContactsTab />
          }
          {/*
            this.state.currentTab === 1 &&
            <ProfileTab />
          */}
          {
            this.state.currentTab === 1 &&
            <PassportTab />
          }
          {
            this.state.currentTab === 2 &&
            <AddressTab />
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modal/SettingsModal/ProfileSettings/index.js